import { render, staticRenderFns } from "./DonorIdentification.vue?vue&type=template&id=2f23d0b9"
import script from "./DonorIdentification.vue?vue&type=script&lang=js"
export * from "./DonorIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports